var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpendSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28516",
    "data-name": "Group 28516",
    transform: "translate(-20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_15",
    "data-name": "Union 15",
    transform: "translate(20)",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.7508999705314636 14.24477863311768 L 0.7508999705314636 11.77393054962158 L 0.7508999705314636 11.76294994354248 L 0.7505800127983093 11.75197982788086 C 0.7502099871635437 11.73947048187256 0.75 11.72698974609375 0.75 11.71440029144287 L 0.75 1.999800086021423 C 0.75 1.310660123825073 1.311059951782227 0.7500001192092896 2.000699996948242 0.7500001192092896 L 16.00020027160645 0.7500001192092896 C 16.68934059143066 0.7500001192092896 17.25 1.310660123825073 17.25 1.999800086021423 L 17.25 11.71440029144287 C 17.25 12.40354061126709 16.68934059143066 12.96420001983643 16.00020027160645 12.96420001983643 L 2.390470027923584 12.96420001983643 L 2.089499950408936 12.96420001983643 L 1.872009992599487 13.17226028442383 L 0.7508999705314636 14.24477863311768 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.500900030136108 12.50644207000732 C 1.757292032241821 12.31758403778076 2.068701267242432 12.21420001983643 2.390470027923584 12.21420001983643 L 16.00020027160645 12.21420001983643 C 16.27578926086426 12.21420001983643 16.5 11.989990234375 16.5 11.71440029144287 L 16.5 1.999800086021423 C 16.5 1.724210143089294 16.27578926086426 1.50000011920929 16.00020027160645 1.50000011920929 L 2.000699996948242 1.50000011920929 C 1.724609971046448 1.50000011920929 1.5 1.724210143089294 1.5 1.999800086021423 L 1.50025999546051 11.73003005981445 C 1.50068998336792 11.74466037750244 1.500900030136108 11.75928974151611 1.500900030136108 11.77393054962158 L 1.500900030136108 12.50644207000732 M 0.0008999999845400453 16.00020027160645 L 0.0008999999845400453 11.77393054962158 C 0.0003199999919161201 11.75411987304688 0 11.73435020446777 0 11.71440029144287 L 0 1.999800086021423 C 0 0.895500123500824 0.8955000042915344 1.358032193365943e-07 2.000699996948242 1.358032193365943e-07 L 16.00020027160645 1.358032193365943e-07 C 17.10449981689453 1.358032193365943e-07 18 0.895500123500824 18 1.999800086021423 L 18 11.71440029144287 C 18 12.81869983673096 17.10449981689453 13.71420001983643 16.00020027160645 13.71420001983643 L 2.390470027923584 13.71420001983643 L 0.0008999999845400453 16.00020027160645 Z",
    stroke: "none",
    fill: "#fc3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28515",
    "data-name": "Group 28515",
    transform: "translate(-1 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(33)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(29)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(25)",
    fill: "#fc3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendSms);
export default __webpack_public_path__ + "static/media/spend-sms.58188c0109875a8e54a276a324d302a3.svg";
export { ForwardRef as ReactComponent };